import { FlaskConical, Microscope, Shield, Truck } from "lucide-react";

export default function About() {
  return (
    <div data-testid="about-page" className="min-h-screen">
      <section className="border-b-[3px] border-black bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <div className="font-mono-ui text-xs text-[#ff1493]">— ABOUT UKPR</div>
            <h1 className="font-display text-5xl md:text-6xl leading-none mt-3">
              Peptides, built for <span className="text-[#ff1493]">research</span>.
            </h1>
            <p className="mt-6 text-base md:text-lg text-black/70 max-w-2xl">
              UK Peptide Research is an independent UK supplier of research-grade peptides and
              laboratory supplies. We source from vetted manufacturers, batch-test for purity,
              and ship from the United Kingdom via tracked courier.
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="border-[4px] border-black bg-[#00d4ff] p-6">
              <div className="font-mono-ui text-[11px]">EST.</div>
              <div className="font-display text-6xl">2024</div>
              <div className="font-mono-ui text-[11px] mt-2">UNITED KINGDOM · GLASGOW</div>
            </div>
          </div>
        </div>
      </section>

      <section className="border-b-[3px] border-black">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid md:grid-cols-2 gap-10">
          <div>
            <div className="font-mono-ui text-xs text-[#00d4ff]">— WHAT WE STAND FOR</div>
            <h2 className="font-display text-4xl md:text-5xl leading-none mt-3">Transparent science. Zero hype.</h2>
          </div>
          <div className="space-y-5 text-base text-black/80">
            <p>
              The peptide industry is noisy. We cut through it by publishing third-party assays
              with every batch, printing lot numbers on every vial, and only listing compounds
              we would run in our own lab.
            </p>
            <p>
              We&rsquo;re a small team of chemists and researchers &mdash; not an affiliate farm &mdash;
              working out of a Glasgow lab space. We ship within 48 hours of order, every
              order discreetly packaged.
            </p>
          </div>
        </div>
      </section>

      <section className="border-b-[3px] border-black bg-[#f4f4f5]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-5">
          {[
            { Icon: FlaskConical, t: "Verified batches", d: "HPLC & mass-spec on every batch, COAs available on request." },
            { Icon: Microscope, t: "Research-first", d: "We only stock what we would use in our own lab setups." },
            { Icon: Shield, t: "Secure checkout", d: "Encrypted checkout, discreet packaging, strict data handling." },
            { Icon: Truck, t: "UK dispatch", d: "Shipped same/next working day via tracked UK courier." },
          ].map(({ Icon, t, d }) => (
            <div key={t} className="bg-white border-[3px] border-black p-5 shadow-brut-sm">
              <Icon className="w-7 h-7 text-[#ff1493]" strokeWidth={2.5} />
              <div className="font-display text-lg mt-3">{t}</div>
              <div className="text-sm text-black/70 mt-2">{d}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
